/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    API_KEYS_title: "Clés API",
    API_KEYS_label: "clé",
    API_KEYS_pluralLabel: "clés",
    API_KEYS_description:
        "Une clé ouvre toute l'API Prospeneo au nom d'un utilisateur, avec ses droits : son " +
        "assistant IA (MCP) ou son programme agit comme lui. Le client voit ses clés dans " +
        "Paramétrage → Clés MCP et API, et peut les réafficher ; il ne peut ni en créer ni en " +
        "révoquer.",
    API_KEYS_generate: "Générer une clé",
    API_KEYS_generateTitle: "Générer une clé API",
    API_KEYS_confirmGenerate: "Générer",
    API_KEYS_close: "Fermer",
    API_KEYS_columnUser: "Utilisateur",
    API_KEYS_columnName: "Libellé",
    API_KEYS_columnPrefix: "Début de la clé",
    API_KEYS_columnStatus: "Statut",
    API_KEYS_columnCreated: "Créée le",
    API_KEYS_columnLastUsed: "Dernière utilisation",
    API_KEYS_columnExpires: "Expire le",
    API_KEYS_status_active: "Active",
    API_KEYS_status_expired: "Expirée",
    API_KEYS_status_revoked: "Révoquée",
    API_KEYS_neverUsed: "Jamais",
    API_KEYS_noLimit: "Sans limite",
    API_KEYS_actionReveal: "Afficher la clé",
    API_KEYS_actionRevoke: "Révoquer",
    API_KEYS_revokeConfirm:
        "Révoquer la clé « {name} » de {email} ? Ce qui l'utilise perd l'accès immédiatement. " +
        "C'est définitif.",
    API_KEYS_revoked: "La clé a été révoquée.",
    API_KEYS_revealFailed:
        "Cette clé ne peut pas être affichée : elle est révoquée, expirée, ou a été créée avant " +
        "le 06/10/2026. Générez-en une nouvelle.",
    API_KEYS_emptyTitle: "Aucune clé API",
    API_KEYS_loadFailedTitle: "Liste indisponible",
    API_KEYS_loadFailed: "La liste des clés n'a pas pu être chargée. Réessayez plus tard.",
    API_KEYS_emptyDescription: "Générez la première clé d'un client avec « Générer une clé ».",
    API_KEYS_fieldUser: "Utilisateur",
    API_KEYS_fieldUserPlaceholder: "Nom ou e-mail de l'utilisateur",
    API_KEYS_changeUser: "Changer",
    API_KEYS_noUserFound: "Aucun utilisateur trouvé.",
    API_KEYS_fieldName: "Libellé",
    API_KEYS_fieldNamePlaceholder: "Ex. MCP Claude Desktop",
    API_KEYS_fieldExpires: "Date d'expiration (facultative)",
    API_KEYS_clearDate: "Effacer la date",
    API_KEYS_fieldExpiresHint:
        "Valable jusqu'à la fin de ce jour, heure de Paris. Sans date, la clé n'expire jamais.",
    API_KEYS_generatedFor:
        "Clé générée pour {email}. Elle reste consultable ensuite par « Afficher la clé ».",
    API_KEYS_copy: "Copier",
    API_KEYS_copied: "Copiée",
    API_KEYS_headersHelp: "À transmettre au client, l'un ou l'autre en-tête :"
};
